import { Component, OnInit, HostListener } from '@angular/core';
import { ActivityIndicatorService } from './Services/activityIndicator.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from './constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ePassword';
  public ShowLoading: boolean;
  availableLanguages = AppConfig.AvailableLanguages;
  defaultLanguage: string;
  selectedLanguage: string;
  public innerHeight: any;


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerHeight = window.innerHeight;
  }

  constructor(private activityIndicator: ActivityIndicatorService, private translate: TranslateService) {
    this.activityIndicator.IsBusy.subscribe(x => {
      this.ShowLoading = x;
    });

    // this language will be used as a fallback when a translation isn't found in the current language
    localStorage.setItem('DefaultLanguage', 'en');
    this.defaultLanguage = localStorage.getItem('DefaultLanguage');
    translate.setDefaultLang(this.defaultLanguage);

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    if (!localStorage.getItem('SelectedLanguage')) {
      this.selectedLanguage = this.defaultLanguage;
    } else {
      this.selectedLanguage = localStorage.getItem('SelectedLanguage');
    }

    translate.use(this.selectedLanguage);

    this.availableLanguages = AppConfig.AvailableLanguages;

  }

  ngOnInit() {
    this.innerHeight = window.innerHeight;
  }

  changeLanguage(languageCode) {
    this.translate.use(languageCode);
    localStorage.setItem('SelectedLanguage', languageCode);
    this.selectedLanguage = languageCode;
  }

}
